import React from 'react';
import bemBlock from '@gik/core/utils/bemBlock';
import { translationKeys } from './i18n/en';
import { useTranslation } from 'react-i18next';
import { HTMLParser, Image } from '@gik/ui';
import { getAssetsUrl } from '@gik/core/utils/LinkUtils';

export default function BenefitsHero(): React.ReactElement {
  const bem = bemBlock('benefits-page-hero');
  const bemItem = bemBlock('benefits-page-hero-item');
  const { t } = useTranslation();
  return (
    <div className={bem()}>
      <div className={bemItem(null, 'danger')}>
        <Image
          src={[
            `${getAssetsUrl()}marketing/benefits/beforeIMG1x.png`,
            `${getAssetsUrl()}marketing/benefits/beforeIMG@2x.png 2x`,
          ]}
          alt={t(translationKeys.withoutTitle)}
        />
        <main>
          <span className={bemItem('title')}>{t(translationKeys.withoutTitle)}</span>
          <p>{HTMLParser({ rawHtml: t(translationKeys.withoutDescription) })}</p>
        </main>
      </div>
      <div className={bemItem(null, 'success')}>
        <Image
          src={[
            `${getAssetsUrl()}marketing/benefits/afterIMG1x.png`,
            `${getAssetsUrl()}marketing/benefits/afterIMG@2x.png 2x`,
          ]}
          alt={t(translationKeys.withTitle)}
        />
        <main>
          <span className={bemItem('title')}>{t(translationKeys.withTitle)}</span>
          <p>{HTMLParser({ rawHtml: t(translationKeys.withDescription) })}</p>
        </main>
      </div>
    </div>
  );
}
